module.exports = __webpack_public_path__ + "static/media/BOT.5df3ac13.png";